var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93555 9.8065V5.19361C3.93555 4.85995 4.06809 4.53996 4.30402 4.30402C4.53996 4.06809 4.85995 3.93555 5.19361 3.93555C5.52727 3.93555 5.84726 4.06809 6.08319 4.30402C6.31912 4.53996 6.45167 4.85995 6.45167 5.19361V9.8065",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.38721V12.113C14 14.7763 11.8408 16.9356 9.17747 16.9356H8.75811C6.0948 16.9356 3.93555 14.7763 3.93555 12.113V9.38721",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45142 11.0643V8.96753C6.45142 8.63387 6.58396 8.31388 6.81989 8.07795C7.05583 7.84202 7.37582 7.70947 7.70948 7.70947C8.04313 7.70947 8.36313 7.84202 8.59906 8.07795C8.83499 8.31388 8.96754 8.63387 8.96754 8.96753M8.96754 8.96753V11.0643M8.96754 8.96753C8.96754 8.63387 9.10008 8.31388 9.33601 8.07795C9.57195 7.84202 9.89194 7.70947 10.2256 7.70947C10.5593 7.70947 10.8792 7.84202 11.1152 8.07795C11.3511 8.31388 11.4837 8.63387 11.4837 8.96753M11.4837 8.96753V11.0643M11.4837 8.96753C11.4837 8.63387 11.6162 8.31388 11.8521 8.07795C12.0881 7.84202 12.4081 7.70947 12.7417 7.70947C13.0754 7.70947 13.3954 7.84202 13.6313 8.07795C13.8672 8.31388 13.9998 8.63387 13.9998 8.96753V11.0643",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38707 5.19354C9.38806 4.29586 9.10001 3.42172 8.56556 2.70048C8.17596 2.17274 7.66783 1.74391 7.08212 1.44854C6.49641 1.15318 5.84951 0.999535 5.19354 1C4.5375 0.999469 3.89051 1.15308 3.30472 1.44845C2.71894 1.74382 2.21074 2.17268 1.8211 2.70048C1.28682 3.42178 0.998927 4.29591 1 5.19354",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.a4b20ae790f60e2ce3fce6b0cacf65e6.svg";
export { ForwardRef as ReactComponent };